import { TypesafeStructuredText } from "datocms-structured-text-utils"
import * as React from "react"
import { StructuredText } from "react-datocms"

import { useLocale } from "../../utils/hooks/use-locale"
import {
  isEmptyStructuredText,
  isSingleParagraph,
} from "../../utils/structured-text/structured-text-checks"
import { datoInlineLink, datoLink, noParagraphs } from "./utils"

interface Props {
  data?: TypesafeStructuredText
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customNodeRules?: any[]
}

const StructuredTextWithLink = ({ data, customNodeRules = [] }: Props) => {
  const locale = useLocale()
  if (isEmptyStructuredText(data)) return null
  const nodeRules = [
    datoLink,
    ...(isSingleParagraph(data) ? [noParagraphs] : []),
    ...customNodeRules,
  ]
  return (
    <StructuredText
      data={data}
      customNodeRules={nodeRules}
      renderInlineRecord={record => datoInlineLink(record, locale)}
    />
  )
}

export default StructuredTextWithLink
